import React from "react";
import styled from "styled-components";
import { MenuPageSubMenu } from "../app/Menus/MenuPageSubMenu";
import { SubMenuMinDimensions } from "../styled/SubMenuMinDimensions";
import { Heading } from "./Heading";

const TwoCol = styled.div<{ hasSubmenu: boolean }>`
  display: grid;
  width: 100%;
  grid-template-columns: ${({ hasSubmenu }) =>
    hasSubmenu ? "auto auto" : "auto"};

  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        grid-column-gap: ${props.theme.spacePx("base", 7)};      
      `;
    })}
`;

const PushDown = styled.div`
  width: 100%;
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        line-height: 10px;
        padding-top:  calc(${props.theme.spacePx(
          breakpoint,
          9
        )} - calc( -1 * ${props.theme.spaceFontTop(breakpoint, `h3Heading`)}));

        & h1 {
          margin-bottom: 0;
        }
      
      `;
    })}
`;

export const PageSubMenu = ({ title, menu }: { title: string; menu: any }) => {
  return (
    <TwoCol hasSubmenu={menu?.length > 0}>
      <SubMenuMinDimensions
        spaceMinHeight={6}
        alignItems="flex-start"
        maxWidth="90vw"
      >
        <PushDown>
          <Heading
            space={7}
            heading="h3"
            asTag="h1"
            inline
            trimmed
            html={title}
          />
        </PushDown>
      </SubMenuMinDimensions>

      {menu?.length > 0 && (
        <SubMenuMinDimensions
          spaceMinHeight={6}
          alignSelf="end"
          alignItems="flex-start"
          justifyContent="flex-end"
        >
          <MenuPageSubMenu menu={menu} />
        </SubMenuMinDimensions>
      )}
    </TwoCol>
  );
};
